import Skeleton from 'react-loading-skeleton';
import { DateFormatter } from '../../utils/DateFormatter';
import PropTypes from 'prop-types';
import { useState } from 'react';
import QuestionPreviewModal from '../../pages/assignments/components/QuestionPreviewModal';

const StudentWiseReport = ({studentReportData})=>
{
  const [showQuestionPreviewModal, setShowQuestionPreviewModal] = useState(false);
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [selectedQuestionAssignmentId, setSelectedQuestionAssignmentId] = useState(null);

  const handleQuestionPreview=(qId,aId)=>
  {
    setSelectedQuestionId(qId);
    setSelectedQuestionAssignmentId(aId);
    setShowQuestionPreviewModal(true);
  };
        
  return (<>
    <table className='table reportTable'>
      {studentReportData? (
        <>
          <thead className='thead-light align-middle'>
            <tr>
              <th scope="col" className='fw-medium text-center'>
                        Question
              </th>
              <th scope="col" className='fw-medium text-center'>
                        First Time Viewed
              </th>
              <th scope="col" className='fw-medium text-center'>
                        Last Time Viewed
              </th>
              <th scope="col" className='fw-medium text-center'>
                        Times Viewed
              </th>
              <th scope="col" className='fw-medium text-center'>
                <span>Total Time On Question <span className='fs-7 fw-normal'>(HH:MM:SS)</span></span>
              </th>
            </tr>
          </thead>
          <tbody>
            {studentReportData?.map((item) => (
              <tr key={`${item.questionIndex}-record`}>
                <td className='text-center' onClick={()=> handleQuestionPreview(item.questionId, item.assignmentId)}><span className='border-b-2 fw-600 clickable-link'>{item.questionIndex}</span></td>
                <td className='text-center'>{DateFormatter.toLongDateTime(item.firstTimeViewed)}</td>
                <td className='text-center'>{DateFormatter.toLongDateTime(item.lastTimeViewed)}</td>
                <td className='text-center'>{item.numberOfTimesViewed}</td>
                <td className='text-center info-text'>{item.totalTime}</td>
              </tr>
            ))}
            {studentReportData?.length == 0 &&<tr>
              <td colSpan={6} className='text-center text-danger'>You have no assignments or self study sessions that were taken in time on task mode!</td></tr>}
          </tbody>
        </>
      ):(
        <><tr className="score-table-head">
          <th> <Skeleton /></th>
          <th> <Skeleton /></th>
          <th> <Skeleton /></th>
          <th> <Skeleton /></th>
          <th> <Skeleton /></th>
        </tr>
        <tr className="tabel-body">
          <td><Skeleton /></td>
          <td><Skeleton /></td>
          <td><Skeleton /></td>
          <td><Skeleton /></td>
          <td><Skeleton /></td>
        </tr>
        <tr className="tabel-body">
          <td><Skeleton /></td>
          <td><Skeleton /></td>
          <td><Skeleton /></td>
          <td><Skeleton /></td>
          <td><Skeleton /></td>
        </tr>
        <tr className="tabel-body">
          <td><Skeleton /></td>
          <td><Skeleton /></td>
          <td><Skeleton /></td>
          <td><Skeleton /></td>
          <td><Skeleton /></td>
        </tr>
        </>
      )}
    </table>

    <QuestionPreviewModal
      isOpen={showQuestionPreviewModal}
      onClose={() => setShowQuestionPreviewModal(false)}
      questionId={selectedQuestionId}
      assignmentId={parseInt(selectedQuestionAssignmentId)}
      isPublicAssignment={false}
    />
  </>);
};

StudentWiseReport.propTypes = {
  studentReportData : PropTypes.object
};

export default StudentWiseReport;